import { StepConnectorClasskey } from '@material-ui/core/StepConnector';

const MuiStepConnector = (): Partial<Record<StepConnectorClasskey, unknown>> => ({
    root: {},
    /* Styles applied to the root element if `alternativeLabel={true}`. */
    alternativeLabel: {
        left: 'calc(-50% + 12px)',
        right: 'calc(50% + 12px)',
    },
    /* Styles applied to the root element if `orientation="horizontal"`. */
    lineHorizontal: {
        borderTopWidth: 2,
    },
    /* Styles applied to the root element if `orientation="vertical"`. */
    lineVertical: {
        borderLeftWidth: 2,
    },
    /* Styles applied to the root element if `orientation="vertical"`. */
    vertical: {
        padding: 0,
    },
});

export default MuiStepConnector;
